import { FlexPolicyRequestDTO } from "../modules/home/home.model";
import SendRequest from "../services/sendRequest.service";

class SIProtectDetailsRequest {
	forEmail: boolean = false;
	forMobile: boolean = false;
	subscribe: boolean = true;
}

export class AuraeHealthRedirectRequest {
    first_name: string;
    last_name: string;
    dob: string;
    //  "1989-05-04";
}
  
  export const base_Profile_Api = async() => {
    const url = `${process.env.REACT_APP_API_BASE_URL}/profile/base-profile`;
    const response = await SendRequest.instance.get(url);
    return response;
  };
  
  export const Config_Api = async(countryID : any) => {
    const url = `${process.env.REACT_APP_API_BASE_URL}/master/config?countryId=${countryID}`;
    const response = await SendRequest.instance.post(url,{});
    return response;
  };
 
  export const profile_Config_Api = async() => {
    const url = `${process.env.REACT_APP_API_BASE_URL}/profile/config`;
    const response = await SendRequest.instance.get(url);
    return response;
  };

export const  siProtectData = async () =>{
    const url = `${process.env.REACT_APP_API_BASE_URL}/profile/siProtect`;
        let response = await SendRequest.instance.get(url);
        return response;
  }

export const  siProtectChange = async (payload : SIProtectDetailsRequest) =>{
    const url = `${process.env.REACT_APP_API_BASE_URL}/profile/siProtect`;
            let response = await SendRequest.instance.post(url,payload);
        return response;
  }

  export const  bankAccountDetails = async () =>{
    const url = `${process.env.REACT_APP_API_BASE_URL}/profile/bankAccountDetails`;
    let response = await SendRequest.instance.get(url);
    return response;
  }
  
  export const  deleteBankDetail = async () =>{
    const url = `${process.env.REACT_APP_API_BASE_URL}/profile/bankAccountDetails`;
    let response = await SendRequest.instance.delete(
        url,
        {}
      )
    return response;
  }


  export const fetchFlexPolicies = async () => {
    const url = `${process.env.REACT_APP_API_BASE_URL}/claimList/flexDetails`;
    let response = await SendRequest.instance.get(url);
    return response;
  }

  export const fetchCorporateConfig = async () => {
    const url = `${process.env.REACT_APP_API_BASE_URL}/CorporateConfig`;
    let response = await SendRequest.instance.get(url);
    return response;
  }

  export const getAuraeHealthRedirectUrl = async(req: AuraeHealthRedirectRequest) => {
    const url = `${process.env.REACT_APP_API_BASE_URL}/master/vendor/redirect-url`;
    const response = await SendRequest.instance.post(url,req);
    return response;
  };